import { ChevronDown, Funnel } from "lucide-react";
import React from "react";
import { useDispatch } from "react-redux";

import { IgAvatar, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { openDrawer } from "@src/store/slices/drawers";
import { AnalyticsActiveFilterType } from "@src/store/types/dashboardFilters";

interface FiltersButtonProps {
  activeFilterArray: AnalyticsActiveFilterType[];
}
export const FiltersButton = ({ activeFilterArray }: FiltersButtonProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Grid
      data-testid="analytics-filters-button"
      container
      wrap={"nowrap"}
      alignItems={"center"}
      direction={"row"}
      columnSpacing={0.8}
      sx={{ "&:hover": { cursor: "pointer" } }}
      onClick={() => {
        dispatch(openDrawer({ type: "analyticsFilters" }));
      }}
    >
      <Grid item mt={0.7}>
        <Funnel size={16} />
      </Grid>
      <Grid item>
        <IgTypography>Filter</IgTypography>
      </Grid>
      {activeFilterArray.length > 0 && (
        <Grid item>
          <IgAvatar
            variant={"circular"}
            sx={{
              width: "16px",
              height: "16px",
              backgroundColor: theme.igBackgroundColors.accentSolid,
            }}
          >
            <IgTypography variant={"body3"} sx={{ color: "white" }}>
              {activeFilterArray.length}
            </IgTypography>
          </IgAvatar>
        </Grid>
      )}
      <Grid item mt={0.8}>
        <ChevronDown size={16} />
      </Grid>
    </Grid>
  );
};
